import { APP_PATHS } from "./paths";

export const FOOTER_NAV = Object.freeze({
  acount: [
    { label: "طلباتي السابقة", to: APP_PATHS.PREVIOUS_ORDERS.url },
    { label: "رصيدي", to: APP_PATHS.WALLET.url },
  ],
  offers: [
    { label: "عروض و خصومات", to: APP_PATHS.PROMOTIONS.url },
    { label: "جديد من موتور", to: APP_PATHS.NEW_SKUS.url },
    { label: "منتجات علشانك", to: APP_PATHS.RECOMMENDED_SKUS.url },
  ],
});
